import { useEffect } from 'react';
import { useAuth } from '../auth/AuthProvider.js';
import { sentrySetUser } from './sentry.js';

/**
 * The signed-in account's internal UUID on every Sentry event (`null` once signed
 * out). Mounted once INSIDE `<AuthProvider>` (it reads `useAuth`). Renders nothing;
 * a no-op when Sentry is off (no DSN).
 */
export function SentryUserBridge(): null {
  const { user } = useAuth();
  const id = user?.id ?? null;
  useEffect(() => {
    sentrySetUser(id ? { id } : null);
  }, [id]);
  return null;
}
